import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=313f55de&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=ts"
export * from "./Recharge.vue?vue&type=script&lang=ts"
import style0 from "./Recharge.vue?vue&type=style&index=0&id=313f55de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f55de",
  null
  
)

export default component.exports